import axios from 'axios'
import store from '../store/index';
import common from "../units/common.js";

import { Loading, Message } from 'element-ui';
axios.defaults.timeout = 50000;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

// let orgInfo = { Id:"", OrgId:"",Domain:""};
let loadingInstance;
let loadingStatus = false;
let mobilePort = 9814;
if (process.env.NODE_ENV == 'development') {
  axios.defaults.baseURL = 'http://localhost:9092/';

  //axios.defaults.baseURL = 'http://read.booksfor.net:9816/'
  // mobilePort = 8081;
  // axios.defaults.baseURL = 'http://read.booksfor.net:9815/userapi/';
  // mobilePort = 9815;
} else if (process.env.NODE_ENV == 'testing') {
  axios.defaults.baseURL = 'http://read.booksfor.net:9816/';
  mobilePort = 9814;
} else if (process.env.NODE_ENV == 'production') {
  // if (window.location.host.indexOf('booksfor') != -1) {
  //   axios.defaults.baseURL = 'http://read.booksfor.net:9816/';
  // }
  // else {
  //   axios.defaults.baseURL = 'https://bs-api.h-read.net/';
  // }
  axios.defaults.baseURL ='/userapi/';
  mobilePort = 9814;
}
let ipAddress = axios.defaults.baseURL;

axios.interceptors.request.use((config) => {
  return config;
}, (error) => {
  return Promise.reject(error);
});

// const _serverUrl = {
//     UAT: "https://admin-api-mr.51zhaoshu.net",
//     TEST: "https://admin-api-mr.51zhaoshu.net",
//     PROD: "https://admin-api-mr.51zhaoshu.net", // 后面改成https
// }
const _serverUrl = {
  UAT: "http://localhost:9092",
  TEST: "http://read.booksfor.net:9816",
  PROD: "https://bs-api.h-read.net", // 后面改成https
}
let serverUrl = ''
let port = ''
// let mobileServerUrl=''
if (process.env.NODE_ENV === 'development') {
  serverUrl = _serverUrl.UAT
  port = ':' + location.port
  // mobileServerUrl=_mobileServerUrl.UAT
}
if (process.env.NODE_ENV === 'testing') {
  serverUrl = _serverUrl.TEST
  port = ''
  // mobileServerUrl=_mobileServerUrl.TEST
}
if (process.env.NODE_ENV === 'production') {
  serverUrl = _serverUrl.PROD
  port = ''
  // mobileServerUrl=_mobileServerUrl.PROD
}

axios.interceptors.response.use((res) => {
  if (res.headers.etime < 1) { // 刷新token
    replaceToken();
  }
  if (res.data.code != -27) {
    if (res.data.code > -31 && res.data.code < -20) {
      common.delToken();
      return;
    }
  }
  closeLoading();
  checkResponse(res);
  return Promise.resolve(res);
}, (error) => {
  // if(error.message==="Network Error"){
  //     window.location.href='/login';
  // }
  closeLoading();
  let httpMessage = '';
  if (error.response) {

    if (error.response.data && error.response.data.message) {
      httpMessage = error.response.data.message;
    } else if (error.response.status == '404') {
      httpMessage = "未找到请求地址";
    }
  } else {
    httpMessage = '服务器处理异常'
  }
  redirect(error.response || {}, httpMessage);
  return Promise.reject(error.response);
});
function closeLoading() {
  if (loadingInstance) {
    loadingInstance.close();
  }
  if (loadingStatus) {
    loadingStatus = false;
    if (loadingInstance) {
      loadingInstance.close();
    }
  }
}
function checkResponse(res) {
}
let _vue = null
const _Authorization = 'Authorization';
function init(vue) {
  _vue = vue;
}

function showLoading(loading) {
  if (!loading || loadingStatus) {
    return;
  }
  loadingInstance = Loading.service({
    target: '#loading-container',
    customClass: "el-loading",
    text: typeof loading === "string" ? loading : '正在处理.....',
    spinner: 'el-icon-loading',
    background: 'rgba(58, 61, 63, 0.32)'
  });
}

/*
  url
  params请求后台的参数,如：{name:123,values:['a','b','c']}
  loading是否显示遮罩层,可以传入true.false.及提示文本
  config配置信息,如{timeout:3000,headers:{token:123}}
*/
function post(url, params, loading, config) {
  showLoading(loading);
  axios.defaults.headers[_Authorization] = common.getToken();
  return new Promise((resolve, reject) => {
    axios.post(url, params, config)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err && err.data && err.data.message ? err.data.message : '服务器处理异常');
      })
      .catch((error) => {
        reject(error)
      })
  })
}
function postParam(url, params, loading, config) {
  showLoading(loading);
  return new Promise((resolve, reject) => {
    axios({
      method: "POST",
      url: url,
      params,
      headers: {
        Authorization: window.localStorage.Token
        // Authorization: 'Bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNobWFjLXNoYTI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyaWQiOiI0NzA3MDFhYzhlOTE0OWU4YjIwNmNmMTg5MTAzMGQ3NCIsInVzZXJuYW1lIjoiMTM4MDAwMDAwMDEiLCJuYmYiOjE2NTc3MDI2NTMsImV4cCI6MTY2MDI5NDY1MywiaXNzIjoidGVzdCIsImF1ZCI6IkFueSJ9.m7vIgneG9E2ayjT63AowYKSRqJ4Ft5CHc5hfF2kAro0'
      }
    })
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err && err.data && err.data.message ? err.data.message : '服务器处理异常');
      })
      .catch((error) => {
        reject(error)
      })
  })
  // return axios({
  //     method: "POST",
  //     url: url,
  //     params,
  //     // headers: {
  //     //     Authorization: window.localStorage.Token
  //     //     //Authorization: 'Bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNobWFjLXNoYTI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyaWQiOiI0NzA3MDFhYzhlOTE0OWU4YjIwNmNmMTg5MTAzMGQ3NCIsInVzZXJuYW1lIjoiMTM4MDAwMDAwMDEiLCJuYmYiOjE2NTc3MDI2NTMsImV4cCI6MTY2MDI5NDY1MywiaXNzIjoidGVzdCIsImF1ZCI6IkFueSJ9.m7vIgneG9E2ayjT63AowYKSRqJ4Ft5CHc5hfF2kAro0'
  //     // }
  // })
}
async function postParamAsync(url, params, loading, config) { // 同步
  showLoading(loading);
  return await new Promise((resolve, reject) => {
    axios({
      method: "POST",
      url: url,
      params,
      headers: {
        Authorization: window.localStorage.Token
      }
    })
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err && err.data && err.data.message ? err.data.message : '服务器处理异常');
      })
      .catch((error) => {
        reject(error)
      })
  })
}
// =true异步请求时会显示遮罩层,=字符串，异步请求时遮罩层显示当前字符串
function get(url, param, loading, config) {
  showLoading(loading);
  axios.defaults.headers[_Authorization] = common.getToken();
  return new Promise((resolve, reject) => {
    axios.get(url, config)
      .then(response => {
        resolve(response.data)
      }, err => {
        reject(err)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

function createXHR() {
  if (XMLHttpRequest) {
    return new XMLHttpRequest();
  }
  if (ActiveXObject) {
    if (typeof arguments.callee.activeXString !== "string") {
      var versions = [
        "MSXML2.XMLHttp.6.0",
        "MSXML2.XMLHttp",
        "MSXML2.XMLHttp.3.0"
      ];
      for (var i = 0; i < versions.length; i++) {
        try {
          new ActiveXObject(versions[i]);
          arguments.callee.activeXString = versions[i];
          break;
        } catch (e) {
          console.log(e);
        }
      }
    }
    return new ActiveXObject(arguments.callee.activeXString);
  }
}

function redirect(responseText, message) {
  try {
    let responseData = typeof responseText === 'string' ? JSON.parse(responseText) : responseText;
    if ((responseData.hasOwnProperty('code') && responseData.code == 401) ||
      (responseData.data && responseData.data.code == 401)) {
      closeLoading();
      toLogin();
    } else {
      Message.error({
        showClose: true,
        message: message,
        type: 'error'
      });
    }
  } catch (error) {
    console.log(error);
    Message.error({
      showClose: true,
      message: responseText,
      type: 'error'
    });
  }
}
function toLogin() {
  _vue.$router.push({ path: '/login', params: { r: Math.random() } });
}
// 动态刷新token
function replaceToken() {
  try {
    api.GetRefreshToken({}).then((r) => {
      if (r.code === 1) {
        var token = r.token;
        // let second = decodeURIComponent(escape(window.atob(token.split('.')[1])))
        store.commit("saveToken", token);
        // store.commit("saveUserInfo", second);
      } else {
        console.log(r.info);
      }
    })
  } catch (error) {
    console.log(error)
  }
}

function ajax(param) {
  let httpParam =
    Object.assign({
      url: '',
      headers: {},
      param: {},
      json: true,
      success: function () { },
      errror: function () { },
      type: 'post',
      async: true
    }, param);

  httpParam.url = axios.defaults.baseURL + httpParam.url.replace(/\/?/, '');
  httpParam.headers[_Authorization] = common.getToken();
  var xhr = createXHR();
  xhr.onreadystatechange = function () {
    if (xhr.status == 403 || xhr.status == 401) {
      redirect(xhr.responseText);
      return;
    }
    checkResponse(xhr);
    if (xhr.readyState == 4 && xhr.status == 200) {
      httpParam.success(httpParam.json ? JSON.parse(xhr.responseText) : xhr.responseText);
      return;
    }
    if (xhr.status != 0 && xhr.readyState != 1) {
      httpParam.errror(xhr);
    }
  };
  // 初始化请求
  xhr.open(
    httpParam.type,
    httpParam.url,
    httpParam.async
  );
  xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  for (const key in httpParam.headers) {
    xhr.setRequestHeader(key, httpParam.headers[key]);
  }
  let dataStr = '';
  for (const key in httpParam.param) {
    dataStr += key + "=" + httpParam.param[key];
  }
  try {
    xhr.send(dataStr);
  } catch (error) {
    toLogin();
  }
}

ajax.post = function (url, param, success, errror) {
  ajax({ url: url, param: param, success: success, error: errror, type: 'post' })
}
ajax.postParam = function (url, param, success, errror) {
  ajax({ url: url, param: param, success: success, error: errror, type: 'post' })
}
ajax.postParamAsync = function (url, param, success, errror) {
  ajax({ url: url, param: param, success: success, error: errror, type: 'post' })
}
ajax.get = function (url, param, success, errror) {
  ajax({ url: url, param: param, success: success, error: errror, type: 'get' })
}
function reWriteApi(url, methods) {
  return function (params, mode) {
    if (mode) {
      return axios.defaults.baseURL + url;
    }
    if (methods == "Form") {
      return postParam(url, params);
    } else {
      return post(url, params);
    }
  }
}
let api = {
  MobilePort: mobilePort,
  ServerUrl: serverUrl,
  GetOrgInfoByUrl: reWriteApi('Public/GetOrgInfo', "Form"),
  Login: reWriteApi('Auth/Login', "Json"),
  IpLogin: reWriteApi('Auth/IpLogin', "Json"),
  GetSms: reWriteApi('Auth/GetSms', "Form"),
  checkCaptcha: reWriteApi('Auth/checkCaptcha', "Form"),
  captchaUUID: reWriteApi('Auth/captchaUUID', "Form"),
  // 头像保存
  SaveUserPhoto: reWriteApi('Center/SaveUserPhoto', "Form"),

  SubmitUserLikeColumnType: reWriteApi('Center/SubmitUserLikeColumnType', "Json"),

  Browse: reWriteApi('Public/Common/Browse', "Json"),
  GetOrgInfo: reWriteApi('Public/Common/GetOrgInfo', "Form"),
  GetOrgInfoMobile: reWriteApi('PC/Home/GetInfoMobile', 'Form'),
  GetOrgCover: reWriteApi('PC/Home/GetOrgCover', 'Form'),
  GetOrgInfoBySchoolCode: reWriteApi('Public/Common/GetOrgInfoBySchoolCode', "Form"),
  GetADList: reWriteApi('PC/Home/GetADList', "Form"),

  GetColumnList: reWriteApi('Column/GetList', "Json"),
  GetColumnPage: reWriteApi('Column/GetColumnPage', "Json"),
  GetColumnTypeList: reWriteApi('ColumnType/GetList', "Json"),

  GetJwtoken: reWriteApi('Auth/GetUserToken', "Form"),

  GetSmsForLogin: reWriteApi('PCAuthentication/GetSmsForLogin', "Form"),
  CheckSmsForLogin: reWriteApi('PCAuthentication/CheckSmsForLogin', "Form"),
  GetSmsForRegister: reWriteApi('PCAuthentication/GetSmsForRegister', "Form"),
  CheckSmsForRegister: reWriteApi('PCAuthentication/CheckSmsForRegister', "Form"),
  GetSmsForUpdatePassword: reWriteApi('PCAuthentication/GetSmsForUpdatePassword', "Form"),
  GetSmsForUpdatePhone: reWriteApi('PCAuthentication/GetSmsForUpdatePhone', "Form"),

  CheckSmsForUpdatePassword: reWriteApi('PCAuthentication/CheckSmsForUpdatePassword', "Form"),
  GetSchoollist: reWriteApi('PCAuthentication/GetSchoollist', "Form"),
  GoRegister: reWriteApi('PCAuthentication/GoRegister', "Form"),
  GetBrowsePage: reWriteApi('PCReadLog/GetPage', "Json"),

  SubmitFolder: reWriteApi('Folder/Submit', "Json"),
  RemoveFolder: reWriteApi('Folder/Remove', "Form"),
  SubmitCollect: reWriteApi('Collect/Submit', "Form"),
  RemoveCollect: reWriteApi('Collect/RemoveCollect', "Json"),
  RemoveFollow: reWriteApi('Collect/RemoveFollow', "Json"),
  MoveCollect: reWriteApi('Collect/Move', "Json"),
  GetCataloguePage: reWriteApi('PCBook/GetCataloguePage', "Json"),
  GetPCEbookInfo: reWriteApi('PCBook/GetPCEbookInfo', "Json"),

  GetSoundBookInfo: reWriteApi('PCSoundBook/GetInfo', "Json"),
  GetSoundBookChildList: reWriteApi('PCSoundBook/GetChildList', "Form"),
  GetOpenTotal: reWriteApi('Public/Common/GetOpenTotal', "Json"),
  GetHotBooks: reWriteApi('Public/Common/GetHotBooks', "Json"),
  GetMember: reWriteApi('Center/GetMember', "Form"),
  SaveUserInfo: reWriteApi('Center/SaveUserInfo', "Json"),

  GetRefreshToken: reWriteApi('Auth/RefreshToken', "Form"),

  GetOrgInfoFromDomain: reWriteApi('Center/GetOrgInfoFromDomain', "Form"),

  GetJdReadBook: reWriteApi('JdReadBook/GetUrl', "Json"),
  GetColumnBookList: reWriteApi('PCColumn/GetColumnBookList', "Json"),

  GetColumnInfo: reWriteApi('PCColumn/GetColumnInfo', "Form"),

  ReadyBook: reWriteApi('BorrowReturn/readyBook', "Json"),

  BorrowReturnList: reWriteApi('BorrowReturn/list', "Json"),

  GetReadBook: reWriteApi('PCBook/ReadBooK', "Json"),

  GetAddXyd: reWriteApi('WAPBookOrg/addXyd', "Json"),

  GetPublisherList: reWriteApi('Publisher/GetList', "Form"),
  SubmitFollow: reWriteApi('Follow/Submit', "Form"),
  GetHomeRankList: reWriteApi('PC/Home/GetRankList', "Form"),
  GetNavList: reWriteApi('Nav/GetList', "Json"),

  ClassIcalList: reWriteApi('ClassIcal/list', "Form"),
  FindTeacherById: reWriteApi('ClassIcal/findTeacherById', "Form"),
  TeacherById: reWriteApi('ClassIcal/TeacherById', "Form"),
  TeacherOtherEbook: reWriteApi('ClassIcal/TeacherOtherEbook', "Json"),
  ClassIcalBook: reWriteApi('ClassIcal/ClassIcalBook', "Json"),
  ClassIcalBookGroup: reWriteApi('ClassIcal/ClassIcalBookGroup', "Json"),
  ClassIcalBookGroupYear: reWriteApi('ClassIcal/ClassIcalBookGroupYear', "Form"),
  GetRankPage: reWriteApi('PC/Home/GetRankPage', "Json"),

  GetPluginList: reWriteApi('Plugin/GetList', "Json"),

  PublisherGetById: reWriteApi('Publisher/getById', "Form"),
  GetEbookFactoryNew: reWriteApi('Publisher/GetEbookFactoryNew', "Form"),
  GetEbookFactoryHot: reWriteApi('Publisher/GetEbookFactoryHot', "Form"),
  PublisherGetPage: reWriteApi('Publisher/getPage', "Json"),
  GetAlbumPage: reWriteApi('Album/GetPage', "Json"),
  GetAlbumDetail: reWriteApi('Album/GetDetail', "Form"),
  GetBookCatalogPage: reWriteApi('Book/GetBookCatalogPage', "Json"),
  GetBookDetail: reWriteApi('Book/GetDetail', "Form"),

  GetOrgInfoTime: reWriteApi('Center/GetOrgInfoTime', "Form"),



  GetTagList: reWriteApi('Tag/GetList', "Json"),
  getTotal: reWriteApi('BookSheet/GetTotal', "Form"),
  GetBookSheetPage: reWriteApi('BookSheet/GetPage', "Form"),
  GetBookSheet: reWriteApi('BookSheet/GetList', "Form"),
  GetBookSheetAll: reWriteApi('BookSheet/GetListAll', "Form"),
  GetBookSheetAllwithoutNow: reWriteApi('BookSheet/GetListAllwithoutNow', "Form"),
  GetBookSheetPageByCollect: reWriteApi('BookSheet/GetPageByCollect', "Form"),
  GetCollect: reWriteApi('BookSheet/GetCollected', "Form"),
  GetBookList: reWriteApi('BookSheet/GetBelongBook', "Form"),
  InsertLog: reWriteApi('BookSheet/InsertLog', 'Form'),
  getBookAll: reWriteApi('BookSheet/getBookAll', 'Json'),
  addBookSheetAndBelongBook: reWriteApi('BookSheet/addBookSheetAndBelongBook', 'Json'),
  GetBookSheetDetail: reWriteApi('BookSheet/GetBookSheetInfo', 'Form'),
  getMyBooksheet: reWriteApi('BookSheet/GetMyBookSheet', 'Json'),
  removeMyBookSheets: reWriteApi('BookSheet/removeMyBookSheets', 'Json'),
  removeMyBookSheet: reWriteApi('BookSheet/removeMyBookSheet', 'Form'),
  getHistoryData: reWriteApi('BookSheet/getHistoryData', 'Form'),


  GetCategoryList: reWriteApi('Category/GetCategoryList', "Form"),
  GetCategoryListHostAndNew: reWriteApi('Category/GetCategoryListHostAndNew', "Form"),
  GetCategoryTree: reWriteApi('Category/GetCategoryTree', "Form"),
  GetReadLikeConfig: reWriteApi('Book/GetReadLikeConfig', "Form"),

  selectByOne: reWriteApi('Purchase/selectByOne', "Form"),

  GetCollectResult: reWriteApi('Collect/GetCollectResult', "Json"),
  GetFollowResult: reWriteApi('Follow/GetFollowResult', "Json"),
  GetPluginData: reWriteApi('Plugin/GetPluginData', "Json"),

  WAPReadLog: reWriteApi('WAPReadLogPc/GetPage', "Json"),
  updateReadLog: reWriteApi('WAPReadLog/updateReadLog', "Json"),
  PCAuthenticationSetLog: reWriteApi('PCAuthentication/AboutSetLog', "Form"),
  findOrgBook: reWriteApi('WAPBookOrg/findOrgBook', "Form"),
  searchUserType: reWriteApi('Center/searchUserType', "Form"),
  searchPassword: reWriteApi('Center/searchPassword', "Form"),
  checkPhone: reWriteApi('PCAuthentication/checkPhone', "Form"),
  senPhoneCode: reWriteApi('PCAuthentication/senPhoneCode', "Form"),
  updatePhone: reWriteApi('PCAuthentication/updatePhone', "Form"),
  GetBannerList: reWriteApi('Banner/GetList', "Json"),
  GetBannerListPCNew: reWriteApi('Banner/GetListPCNew', "Form"),

  logoutUser: reWriteApi('Center/logoutUser', "Form"),

  returnBookAll: reWriteApi('BorrowReturn/returnBookAll', "Json"),
  GetPurchasePage: reWriteApi('Purchase/GetPage', "Json"),
  ExistPurchase: reWriteApi('Purchase/Exist', "Form"),
  SubmitPurchase: reWriteApi('Purchase/Submit', "Json"),
  SetAboutLog: reWriteApi('Center/AboutSetLog', 'Json'),
  GetClassicsList: reWriteApi('Classics/GetClassicsList'),
  GetClassicsBookPage: reWriteApi('Classics/GetClassicsBookPage', 'Json'),
  GetClassicsBookTagList: reWriteApi('Classics/GetClassicsBookTagList', 'Form'),
  GetClassicsAuthorList: reWriteApi('Classics/GetClassicsAuthorList', 'Form'),
  GetAuthorBookPage: reWriteApi('Classics/GetAuthorBookPage', 'Json'),
  GetUserAuth: reWriteApi('Public/GetUserAuth', "Form"),
  GetModuleList: reWriteApi('Module/GetModuleList', "Json"),
  GetModuleData: reWriteApi('Module/GetModuleData', "Json"),
  GetDefaultModuleResult: reWriteApi('Module/GetDefaultModuleResult', "Json"),
  GetBookLikeChooseResult: reWriteApi('Module/GetBookLikeChooseResult', "Form"),
  GetBookGuessYouLikeResult: reWriteApi('Module/GetBookGuessYouLikeResult', "Form"),


  GetBookServicePage: reWriteApi('Book/GetBookServicePage', "Json"),

}
function getImg(src) {
  if (!src) {
    return;
  }
  return common.getImg(src, axios.defaults.baseURL);
  // return common.getImg(src, "http://read.booksfor.net:9816/");
}
export default { post, postParam, postParamAsync, get, ajax, init, ipAddress, api, port, getImg }



// WEBPACK FOOTER //
// ./src/api/http.js